import DataTable from "../../components/common/DataTable";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { notifications } from "@mantine/notifications";
import { AnalyticsPageLayout, ChartCard, TOOLTIP_STYLE, chartProps } from "./AnalyticsLayout";
import { CreditCard } from "lucide-react";

const subscriptionTrendData = [
  { month: "Jan", basic: 28450, premium: 12680, annual: 8920, family: 5450 },
  { month: "Feb", basic: 31230, premium: 14450, annual: 10230, family: 6340 },
  { month: "Mar", basic: 33890, premium: 16780, annual: 12340, family: 7890 },
  { month: "Apr", basic: 36450, premium: 18920, annual: 14560, family: 9230 },
];

const subscriptionAnalytics = [
  { key: "1", plan: "Basic Monthly", active: 28450, newSubs: 2850, renewals: 1890, revenue: 142250, arpu: 5.0, ltv: 450 },
  { key: "2", plan: "Premium Monthly", active: 12680, newSubs: 1250, renewals: 890, revenue: 203840, arpu: 16.08, ltv: 1440 },
  { key: "3", plan: "Premium Annual", active: 8920, newSubs: 680, renewals: 250, revenue: 80280, arpu: 9.0, ltv: 1800 },
  { key: "4", plan: "Family Plan", active: 5450, newSubs: 320, renewals: 180, revenue: 163500, arpu: 30.0, ltv: 3600 },
];

const subscriptionColumns = [
  { title: "Plan Name", dataIndex: "plan", key: "plan" },
  { title: "Active Subscribers", dataIndex: "active", key: "active", render: (t) => t.toLocaleString() },
  { title: "New Subscriptions", dataIndex: "newSubs", key: "newSubs", render: (t) => t.toLocaleString() },
  { title: "Renewals", dataIndex: "renewals", key: "renewals", render: (t) => t.toLocaleString() },
  { title: "Revenue", dataIndex: "revenue", key: "revenue", render: (t) => `Tsh ${t.toLocaleString()}` },
  { title: "ARPU", dataIndex: "arpu", key: "arpu", render: (t) => `Tsh ${t.toFixed(2)}` },
  { title: "LTV", dataIndex: "ltv", key: "ltv", render: (t) => `Tsh ${t.toLocaleString()}` },
];

const SubscriptionAnalyticsPage = () => {
  const handleExport = (format) => {
    notifications.show({ message: `Exporting as ${format.toUpperCase()}...`, color: "green" });
  };

  return (
    <AnalyticsPageLayout
      icon={CreditCard}
      title="Subscription Analytics"
      subtitle="Subscription plans performance & metrics"
      onExport={handleExport}
    >
      <div className="mb-8">
      <ChartCard title="Subscription Trends">
        <div style={{ height: 350 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={subscriptionTrendData}>
              <CartesianGrid {...chartProps.grid} />
              <XAxis dataKey="month" {...chartProps.axis} />
              <YAxis {...chartProps.axis} />
              <RechartsTooltip contentStyle={TOOLTIP_STYLE} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Line type="monotone" dataKey="basic" stroke="#3b82f6" strokeWidth={2} name="Basic" />
              <Line type="monotone" dataKey="premium" stroke="#10b981" strokeWidth={2} name="Premium" />
              <Line type="monotone" dataKey="annual" stroke="#f59e0b" strokeWidth={2} name="Annual" />
              <Line type="monotone" dataKey="family" stroke="#8b5cf6" strokeWidth={2} name="Family" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </ChartCard>
      </div>

      <ChartCard title="Subscription Plan Performance">
        <DataTable dataSource={subscriptionAnalytics} columns={subscriptionColumns} pagination={false} scroll={{ x: 1000 }} rowKey="key" />
      </ChartCard>
    </AnalyticsPageLayout>
  );
};

export default SubscriptionAnalyticsPage;
